export class CompanyAccess {
  constructor(
    public email: string,
    public password: string = null,
    public passwordRepeat: string = null
  ) { }
}



// WEBPACK FOOTER //
// /var/www/lantago-app/lantago-app-demo/src/app/core/models/company-access.ts